var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMugSaucer = function SvgMugSaucer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 27 27"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.55 5.35H5.4v9.45c0 1.519 1.181 2.7 2.7 2.7h8.1c1.477 0 2.7-1.181 2.7-2.7V5.35h-1.35m2.7 9.45a4.05 4.05 0 0 1-4.05 4.05H8.1a4.05 4.05 0 0 1-4.05-4.05V5.35C4.05 4.633 4.64 4 5.4 4h16.875C24.848 4 27 6.152 27 8.725c0 2.616-2.152 4.725-4.725 4.725H20.25zm2.025-2.7a3.36 3.36 0 0 0 3.375-3.375 3.385 3.385 0 0 0-3.375-3.375H20.25v6.75zm-21.6 9.45h22.95c.337 0 .675.337.675.675 0 .38-.338.675-.675.675H.675A.666.666 0 0 1 0 22.225c0-.338.295-.675.675-.675"
  })));
};
export default SvgMugSaucer;